import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ViewMode} from "../../../models/type/view-mode.enum";
import {ViewModelType} from "../../../models/type/view-model-type.enum";

@Component({
  selector: 'sb-base-renderer',
  templateUrl: './base-renderer.component.html',
  styleUrls: ['./base-renderer.component.scss']
})
export class BaseRendererComponent {

  @Input()
  data: any;

  constructor() {
  }

  uniqueFieldId() {
    return `${this.fieldName()}_${this.recordId()}`;
  }

  fieldType() {
    return this.getElement()?.fieldType;
  }

  fieldName() {
    return this.data.column.field;
  }

  fieldRecord(): any {
    const fieldName = this.data.column.field;
    return this.data._dataFn()[fieldName];
  }

  fieldRecords(): any[] {
    const record = this.fieldRecord();
    return (record === null || record === undefined) ? record : (Array.isArray(record) ? record : [record]);
  }

  fieldValue() {
    const fieldName = this.data.column.field;
    const fieldValue = this.data._dataFn()[fieldName];
    return fieldValue?.value;
  }

  fieldDisplayValue() {
    const fieldName = this.data.column.field;
    const fieldValue = this.data._dataFn()[fieldName];
    return fieldValue?.displayValue;
  }

  renderer() {
    return this.getElement()?.renderer;
  }

  properties() {
    return this.getElement()?.properties || {};
  }

  rendererProperties() {
    return this.getElement()?.rendererProperties || {};
  }

  tableName() {
    return this.data._dataFn().listModel.viewDefinition.table;
  }

  recordId() {
    return this.data._dataFn().id;
  }

  readOnly() {
    return this.getElement().readOnly;
  }

  required() {
    return this.getElement().required;
  }

  viewMode(): ViewMode {
    return this.getElement().viewMode;
  }

  viewModeReadOnly(): boolean {
    return this.getElement().viewMode === ViewMode.READ_ONLY;
  }

  viewModeEdit(): boolean {
    return this.getElement().viewMode === ViewMode.EDIT;
  }

  viewModelType(): ViewModelType {
    return this.data._dataFn().listModel.viewDefinition.viewModelType;
  }

  viewModelTypeDetail(): boolean {
    return this.viewModelType() === ViewModelType.DETAIL;
  }

  viewModelTypeList(): boolean {
    return this.viewModelType() === ViewModelType.LIST;
  }

  elementOrViewModeReadOnly() {
    return this.viewModeReadOnly() || this.readOnly();
  }

  i18nKey(): string {
    return this.getElement().i18nKey;
  }

  private getElement() {
    const fieldName = this.data.column.field;
    const viewDefinition = this.data._dataFn().listModel.viewDefinition;
    return viewDefinition.containers[0].elements.find((e) => e.fieldName === fieldName);
  }
}
